import { render, staticRenderFns } from "./sider-bar.vue?vue&type=template&id=30408bf6&scoped=true"
import script from "./sider-bar.vue?vue&type=script&lang=js"
export * from "./sider-bar.vue?vue&type=script&lang=js"
import style0 from "./sider-bar.vue?vue&type=style&index=0&id=30408bf6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30408bf6",
  null
  
)

export default component.exports